export enum UserRoleRuEnum {
  admin = "Администратор",
  tutor = "Преподаватель",
  supervisor = "Куратор",
  parent = "Родитель",
  student = "Ученик",
  contenter = "Создатель контента",
  assistant = "Помощник",
}

export enum UserRoleEnum {
  admin = "admin",
  tutor = "tutor",
  supervisor = "supervisor",
  parent = "parent",
  student = "student",
  contenter = "contenter",
  assistant = "assistant",
}
